// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Dtuz","select":"Header_select__xoV43","clinic":"Header_clinic__a9ma-"};